<template>
  <Modal
    :value="show"
    width="450"
    :mask-closable="false"
    class-name="blacklist"
    @on-visible-change="onModalChange"
  >
    <div class="content">
      <i class="iconfont icon" style="color:#ff9100;">&#xe616;</i>
      <p class="message">您的公司账户暂无法下单</p>
      <p class="description">请拨打 021-36622199 或联系专享客服</p>
    </div>
    <div slot="footer">
      <Button type="primary" @click="onModalChange(false)">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { Message } from "iview";
import { queryBlackList } from "@/api/user";
export default {
  data() {
    return {};
  },
  computed: {
    show() {
      return this.$store.state.user.showBlackListModal;
    },
  },
  methods: {
    onModalChange(v) {
      this.$store.commit("user/save", {
        showBlackListModal: v,
      });
    },
  },
};
</script>

<style lang="less">
  .blacklist {
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
    .content {
        text-align: center;
        padding-top: 20px;
        .icon {
            font-size: 32px;
        }
    }

    button {
        background: #ff9100;
        border-color: #ff9100;
        width: 50%;
        margin: 0 auto;
        display: block;
    }
    .cancel {
        background: #fff;
        border-color: #dddee1;
        color: #dddee1;
    }
    .confirmBtn {
        width: 30%;
        display: inline-block;
        margin: 0 10px;
    }
    .message {
        margin-top: 10px;
        color: #000;
        font-size: 18px;
        font-weight: 500
    }
    .description {
        font-size: 13px;
        font-weight: bold;
        margin-top: 13px;
    }
    .ivu-modal-footer {
        border: none;
        padding-bottom: 30px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// blacklist-modal.vue?fe46a944